module.exports = {"seasons":[{"id":"spring","order":0,"name":"Spring"},{"id":"summer","order":1,"name":"Summer"},{"id":"fall","order":2,"name":"Fall"},{"id":"winter","order":3,"name":"Winter"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/game_data/seasons.json
// module id = gVo5
// module chunks = 1